import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthStateService } from '../services/auth-state.service';

const SESSION_KEY = 'riskyid_session';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  let token: string | null = null;
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.token) token = parsed.token;
    }
  } catch {}

  if (!token) {
    return next(req);
  }

  if (authState.isTokenExpired(token)) {
    authState.forceLogout();
    if (!router.url.includes('/login')) {
      router.navigate(['/login']);
    }
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
  );
};
